import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  formWrapper: {
    width: '100%',
    maxWidth: 480,
    display: 'flex',
    flexDirection: 'column',
  },
  error: {
    margin: '20px auto 0',
    color: theme.palette.red.main,
  }
}))

export default useStyles;
